import React, { Component, Fragment } from 'react'
import { RouterView } from '@merchant-backend/common-components'
import Title from './Title'
import { Button, Modal } from 'hljd'
import List from './List'
import PushList from './PushList'
import ListStore from './List/store'
import PushListStore from './PushList/store'
import { Provider } from 'mobx-react'
import { hashHistory } from 'react-router'
import { MERCHANT_CONSULT_PHONE } from '@hlj/hlj-constant'

export default class extends Component {
  constructor(props) {
    super(props)
    const {
      location: {
        query: { tab }
      }
    } = this.props
    this.listStore = new ListStore()
    this.pushListStore = new PushListStore()
    this.state = {
      activeTab: tab || '1'
    }
    console.log(props)
  }
  changeTab = key => {
    this.setState({
      activeTab: key
    })
    if (key == '1') {
      this.listStore.initTab('all')
      hashHistory.push('/localMerchant/potentialCustomers')
    }
  }
  showWarning = (title, content) => {
    Modal.warning({
      title: title,
      content: content,
      onOk: () => {},
      onCancel: () => {}
    })
  }
  toCreateBatchPush = () => {
    const { score, status, jumpPage } = this.listStore
    if (status == 2) {
      this.showWarning(
        `您已违规，暂时无法发送，详情请咨询平台运营或致电商家客服：${MERCHANT_CONSULT_PHONE}`
      )
    } else if (score == 0) {
      this.showWarning(
        '点数不足，暂时无法发送',
        <Fragment>
          <a onClick={jumpPage}>如何获得更多点数</a>，详情请咨询平台运营或致电商家客服：{
            MERCHANT_CONSULT_PHONE
          }
        </Fragment>
      )
    } else {
      hashHistory.push('/localMerchant/potentialCustomers/createPush')
    }
  }

  render() {
    const { activeTab } = this.state
    const header = (
      <p style={{ color: '#666', fontSize: 14 }}>
        <label style={{ color: '#ff801a' }}>潜在客资：</label>指有潜力成为正式客资的用户，对店铺/套餐/案例有兴趣但没有主动咨询
      </p>
    )
    const extra = (
      <Button type="primary" onClick={this.toCreateBatchPush}>
        批量推送
      </Button>
    )
    return (
      <Provider listStore={this.listStore} pushListStore={this.pushListStore}>
        <RouterView
          header={header}
          title={
            <Title
              active={activeTab}
              onChange={this.changeTab}
              store={this.listStore}
            />
          }
          extra={extra}
        >
          {activeTab == '1' ? <List /> : <PushList />}
        </RouterView>
      </Provider>
    )
  }
}
